import { DataList } from '@core/components';
import type { TableColumn } from '@core/components/DataList';
import type { PolicyMetrics } from '@core/graphql/types/schema';
import * as reportStyles from '@internal-audit/pages/AuditReportPage.css';
import { Heading, Text } from '@soteria/design-system-ve';
import { useMemo } from 'react';

interface PolicyMetricsSectionProps {
  policyMetrics: PolicyMetrics[];
}

export function PolicyMetricsSection({ policyMetrics }: PolicyMetricsSectionProps) {
  const columns: TableColumn<PolicyMetrics>[] = useMemo(
    () => [
      {
        key: 'policyName',
        header: 'Policy Name',
        render: (item: PolicyMetrics) => <Text>{item.policyName}</Text>,
        width: '30%',
      },
      {
        key: 'triggeredCorrectness',
        header: 'Triggered Correct',
        render: (item: PolicyMetrics) => (
          <Text>
            {item.triggeredCorrectnessCount} ({item.triggeredCorrectnessPercentage.toFixed(1)}%)
          </Text>
        ),
        width: '23.33%',
      },
      {
        key: 'nonTriggeredCorrectness',
        header: 'Non-Triggered Correct',
        render: (item: PolicyMetrics) => (
          <Text>
            {item.nonTriggeredCorrectnessCount} ({item.nonTriggeredCorrectnessPercentage.toFixed(1)}%)
          </Text>
        ),
        width: '23.33%',
      },
      {
        key: 'overallCorrectness',
        header: 'Overall Correct',
        render: (item: PolicyMetrics) => (
          <Text>
            {item.overallCorrectnessCount} ({item.overallCorrectnessPercentage.toFixed(1)}%)
          </Text>
        ),
        width: '23.33%',
      },
    ],
    []
  );

  return (
    <div>
      <Heading level="h4">Policy Performance Assessment</Heading>
      <div className={reportStyles.labelPerformanceSection}>
        <DataList hideEmptyState columns={columns} data={policyMetrics} dataTypeName="policy metric" emptyStateMessage="No policy metrics available." />
      </div>
    </div>
  );
}
